import React, { createContext, useEffect, useState } from "react";
import { tramiteDefault } from "../data/data";

export const DataContextReclamo = createContext();

export const DataProvier = ({ children }) => {
  const [tramite, setTramite] = useState({ ...tramiteDefault });

  const changeHandler = (event) => {
    setTramite({ ...tramite, [event.target.name]: event.target.value });
  };

  return (
    <DataContextReclamo.Provider value={{ tramite, setTramite, changeHandler }}>
      {children}
    </DataContextReclamo.Provider>
  );
};
